import styled from 'styled-components';

export const Card = styled.div`
  min-height: 100px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  padding-bottom: 0;
  border: 2px solid #c4c4c4;
  border-radius: 4px;
`;

export const CardRow = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const GrupoCadencia = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Cadencia = styled.span`
  margin-right: 5px;
`;

export const Texto = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: ${props => props.fontWeight || 'normal'};
  font-size: ${props => props.fontSize || '12px'};
  line-height: 20px;
  text-align: center;
  color: ${props => props.color || '#676A6C'};
  margin-bottom: 3px;
`;
